<template>
  <div id="menu-item" ref="menu-item">
    <el-row class="menu-item-row" type="flex">
      <template v-for="(menuItem, indx) in menuItems">
        <el-col v-if="menuItem.isVisible" :ref="menuItem.id" :id="menuItem.id" :key="indx" :class="['item', menuItem.addClass]">
          <el-button @click="handleMenuItemClick(menuItem.id, menuItem.rounteName, menuItem.fullPath)" :class="['menu-item-btn', menuItem.id]">
            <div :class="['icon', menuItem.id, menuItem.addClass]"></div>
            <div class="name">{{menuItem.name}}</div>
          </el-button>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script src="./menu-items.js"></script>
<style lang="scss" src="./menu-items.scss"></style>
